import { Stack } from '@mui/system';
import { FC } from 'react';
import { CustomTextField } from '../../common/CustomTextField';

interface AnalysisStatistichsInterface {
  disabled: boolean;
  software: string;
}

export const AnalysisStatistichs: FC<AnalysisStatistichsInterface> = ({
  disabled,
}) => {
  return (
    <Stack flex={1} gap={1}>
      <Stack
        flexDirection="unset"
        flexWrap="wrap"
        gap={1}
        sx={{ width: '100%' }}
      >
        <CustomTextField
          name="googleAnalyticsId"
          disabled={disabled}
          label="Google analytics ID"
        />
        <CustomTextField
          name="metaPixelId"
          disabled={disabled}
          label="Meta pixel ID"
        />
      </Stack>
    </Stack>
  );
};
